export default __webpack_public_path__ + "static/media/statistic_ico.004d5ba6.svg";